<script setup>
import { cva } from 'class-variance-authority';

defineProps({
  theme: {
    type: String,
    required: false,
    default: 'outline',
  },
});

const classes = cva(
  'tw-inline-flex tw-items-center tw-gap-[2px] tw-px-[4px] tw-py-[4px] tw-text-[14px] tw-leading-[21px] tw-tracking-[-0.02em] xs2:tw-text-[12px] md:tw-gap-[4px] md:tw-text-[14px]',
  {
    variants: {
      theme: {
        outline:
          'tw-rounded-[100px] tw-border tw-border-gray-300 tw-font-normal tw-text-primary-grey tw-pl-[6px] tw-pr-[8px]',
        orange:
          'tw-rounded-[8px] tw-bg-[#FDEDDF] tw-font-bold tw-text-refreshPrimaryBg-darker',
        grey: 'tw-rounded-[8px] tw-bg-gray-200 tw-font-bold tw-text-gray-700',
      },
    },
  }
);
</script>

<template>
  <div :class="classes({ theme })" data-uh="property-tile-chip">
    <slot name="icon" />
    <span><slot /></span>
  </div>
</template>
